import { MapPin } from '@shared/interfaces/pins.interface';

export class MapsBaseService {
    randomizeLocation(location: string): string {
        return String(Number(location) + (Math.random() - 0.5) / 8000);
    }

    randomizeDuplicatePositions(pins: MapPin[]): MapPin[] {
        if (pins.length == 0) {
            return [];
        }

        const pinsByLocation = {};
        pins.forEach((pin) => {
            const locationKey = pin.latitude + '|' + pin.longitude;
            pinsByLocation[locationKey] ||= [];
            pinsByLocation[locationKey].push(pin);
        });

        const result = [];

        Object.values(pinsByLocation).forEach((pins: MapPin[]) => {
            if (pins.length == 1) {
                result.push(pins[0]);
            } else {
                pins.forEach((pin) => {
                    pin.latitude = this.randomizeLocation(pin.latitude);
                    pin.longitude = this.randomizeLocation(pin.longitude);
                    result.push(pin);
                });
            }
        });

        return result;
    }
}
